(() => {
  if (window.sakuraCollectionHistoryBound) return;
  window.sakuraCollectionHistoryBound = true;

  const storageKey = () => `sakura-collection-scroll:${location.pathname}${location.search}`;

  const saveScroll = () => {
    try {
      sessionStorage.setItem(storageKey(), String(window.scrollY));
    } catch (_) {
      // Storage may be unavailable in restricted browser modes.
    }
  };

  const restoreScroll = () => {
    let stored;
    try {
      stored = sessionStorage.getItem(storageKey());
    } catch (_) {
      return;
    }
    const top = Number.parseInt(stored || '', 10);
    if (!Number.isFinite(top) || top < 0) return;
    requestAnimationFrame(() => window.scrollTo(0, top));
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('.product-card a[href]')) saveScroll();
  });

  window.addEventListener('pageshow', restoreScroll);
  window.addEventListener('load', restoreScroll, { once: true });
  window.addEventListener('popstate', () => window.location.reload());
})();
